import React from 'react';

import { Tab, Tabs } from '@mui/material';
import { useCurrentSidebarTab } from '@wp-block-builder/editor/hooks';

import { useCurrentTemplateType } from '../hooks';

export default function SidebarTabs() {
  const [selectedTab, setSelectedTab] = useCurrentSidebarTab();
  const type = useCurrentTemplateType();

  const renderGeneralTab = () => {
    if (type === 'LAYOUT') {
      return null;
    }
    return <Tab label="General" value="GENERAL" sx={{ minHeight: 48 }} />;
  };

  return (
    <Tabs value={selectedTab} onChange={(_, value) => setSelectedTab(value)}>
      {renderGeneralTab()}
      <Tab label="Styles" value="STYLES" sx={{ minHeight: 48 }} />
      <Tab label="Inspect" value="INSPECT" sx={{ minHeight: 48 }} />
      <Tab label="Data" value="DATA" sx={{ minHeight: 48 }} />
    </Tabs>
  );
}
